export const PageHeader = ({ index, title, subtitle, actions }) => (
  <div className="fade-up mb-10 flex flex-col gap-4 border-b border-border pb-6 lg:flex-row lg:items-end lg:justify-between">
    <div>
      <div className="eyebrow mb-3">
        <span className="font-mono text-[#002FA7]">{index}</span> — Espace de travail
      </div>
      <h1 className="font-display text-4xl font-black tracking-tight text-zinc-950 sm:text-5xl">{title}</h1>
      {subtitle && <p className="mt-3 max-w-2xl text-sm text-muted-foreground md:text-base">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
